import { render, staticRenderFns } from "./ShipmentDetailQuery.vue?vue&type=template&id=2dea941e"
import script from "./ShipmentDetailQuery.vue?vue&type=script&lang=js"
export * from "./ShipmentDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports